import { render, staticRenderFns } from "./returnOrderDetail.vue?vue&type=template&id=2a56f9d2&scoped=true&"
import script from "./returnOrderDetail.vue?vue&type=script&lang=js&"
export * from "./returnOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./returnOrderDetail.vue?vue&type=style&index=0&id=2a56f9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56f9d2",
  null
  
)

export default component.exports